export const apiGrammar = 'https://api.turbosify.com/api/gpt/grammar'
export const apiAuth = 'https://api.turbosify.com/api/auth'
export const apiTest = 'https://api.turbosify.com/api/gpt/test'
export const apiBonus = 'https://api.turbosify.com/api/gpt/bonus'
export const apiGPT = 'https://api.turbosify.com/api/gpt/chat'
export const apiLogin = 'https://api.turbosify.com/api/login'
export const apiListening = 'https://api.turbosify.com/api/gpt/listening'
export const apiVoca = 'https://api.turbosify.com/api/gpt/voca'